/**
 * 配置表字段
 * @author twu
 * @date 2021-06-23
 */
import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'dva';
import {Divider} from 'antd'
import {component_tool, framework_tool, utils_tool} from '@/tool'
import TableFieldEnumForm from './tableFieldEnumForm';

let {$$, checkStrLength} = utils_tool;
let {WizContainer} = framework_tool;
let {WizButton, WizModal, WizTable} = component_tool;


class TableFieldEnumList extends WizContainer {

  componentName = 'tableFieldEnumList';

  static propTypes = {
    value: PropTypes.array,
    onChange: PropTypes.func
  };

  constructor(props) {
    super(props);
    this.state = {
      value: props.value, //[{"key":1,"code":1,"value":"1"},{"key":2,"code":2,"value":"2"}],
      visible: false,
      item: undefined,
      date: new Date().getTime()

    };
    this.deleteKey;
  }

  _componentWillReceiveProps(nextProps) {
    if (this.props.value !== nextProps.value) {
      this.setState({value: nextProps.value});
    }
  }

  /**
   * 监控选择modal的返回值，并且将值反馈给Form
   */
  triggerChange = (nextTargetKeys) => {
    const {onChange} = this.props;
    this.setState({
      value: nextTargetKeys,
      date: new Date().getTime()
    });
    if (onChange) {
      onChange(nextTargetKeys);
    }
  };

  /**
   * 打开modal
   */
  changeVisible(visible) {
    this.setState({
      visible: visible,
      item: undefined,
      date: new Date().getTime()
    });
  };

  /**
   * 确定按钮
   */
  onSubmit = () => {
    const {onChange} = this.props;
    const {value} = this.state;
    this.setState({
      visible: false
    });
    if (onChange) {
      onChange(value);
    }
  };


  editRecord(record) {
    this.setState({
      visible: true,
      item: record,
      date: new Date().getTime()
    });
  }


  /** 行删除 */
  deleteRecord(record) {
    let {value} = this.state;
    const {onChange} = this.props;
    let neoValue = Object.assign([]);
    if (record.key) {
      let content = "确认删除枚举项'" + record.value + "'吗？"
      WizModal.confirm({
        title: '注意', content,
        onOk: () => {
          this.deleteKey = record.key;
          for (let i = 0; i < value.length; i++) {
            if (value[i].key !== this.deleteKey) {
              neoValue.push(value[i])
            }
          }
          value = neoValue;
          this.setState({
            value: value,
            date: new Date().getTime()
          });
          if (onChange) {
            onChange(neoValue);
          }
          wizNotice.success('删除成功');
        },
        onCancel() {
        }
      });
    } else {
      for (let i = 0; i < value.length; i++) {
        if (value[i].key !== record.key) {
          neoValue.push(value[i])
        }
      }
      this.setValue(neoValue);
      wizNotice.success('删除成功');
    }
  }

  propsAndStateOnChange = {};

  /**更新state并返回值给form */
  setValue(value) {
    const {onChange} = this.props;
    this.setState(
      {value: value, visible: false, date: new Date().getTime()},
      () => {
        if (onChange) {
          onChange(value);
        }
      }
    )
  }


  /**
   * 渲染列表
   */
  _renderList() {
    const {placeholder, ...otherProps} = this.props;
    const columns = [
      {
        title: '枚举编码',
        dataIndex: 'code',
        key: 'code',
        width: 100
      },
      {
        title: '枚举名称',
        dataIndex: 'value',
        key: 'value',
        width: 100,
      },
      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 145,
        render: (text, record) => (
          <span>
            <a onClick={e => this.editRecord(record)}> 编辑 </a>
            <Divider type="vertical"/>
            <a onClick={e => this.deleteRecord(record)} key={record.key + "delete"}>删除</a>
          </span>
        ),
      },
    ]
    return (
      <WizTable pagination={false} columns={columns} dataSource={this.state.value}/>
    )

  }

  /** 编辑枚举数据处理 */
  addTableFieldEnum(item) {
    if (!item) {
      item = {};
    }
    let {value} = this.state;
    let neoValue = Object.assign([], value);
    if (item && item.update) {
      neoValue.forEach((data, index) => {
        if (data.key === item.key) {
          data.code = item.code;
          data.value = item.value;
        }
      });
      this.setValue(neoValue);
    } else {
      neoValue.push(item);
      this.setValue(neoValue);
    }
  }


  /**
   * 渲染modal框内的内容
   */
  _renderSelect() {
    return <TableFieldEnumForm key={'editListForm' + new Date().getTime()} tableFieldEnumData={this.state.value}
                               addTableFieldEnum={this.addTableFieldEnum.bind(this)} item={this.state.item}/>
  }

  _render() {
    const {modal, placeholder, ...otherProps} = this.props;
    const {item} = this.state;
    let title = '添加';
    if (item) {
      const {code} = item;
      if (code != null && code != undefined){
        title = '编辑';
      }
    }
    return (
      <>
        {this._renderList()}

        <WizModal
          className="antui-transfer-modal"
          title={title + otherProps.title}
          visible={this.state && this.state.visible}
          width={600}
          footer={null}
          {...modal}
          onCancel={() => this.changeVisible(false)}
          maskClosable
        >
          {this._renderSelect()}
        </WizModal>
        <WizButton type="primary" onClick={() => this.changeVisible(true)}>添加</WizButton>
      </>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {}
};

export default connect(mapStateToProps)(TableFieldEnumList);
